import React from 'react';
import styled from '@emotion/styled';
import { Global, css } from '@emotion/react';
import { Dialog, IconButton, Typography, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { reasons } from '../constant';
import { config } from '@/config/environment';

const CloseButton = styled(IconButton)`
  position: absolute;
  right: 5px;
  top: 5px;
  color: #231727;
`;

const Title = styled(Typography)`
  padding: 0 20px;
  margin-top: 20px;
  font-family: var(--font-cooper-light);
  font-style: normal;
  font-weight: 300;
  font-size: 50px;
  line-height: 109.3%;
  color: #231727;
  margin-bottom: 12px;
`;
const WhyHost = styled(Title)`
  font-family: var(--font-work-sans);
  font-weight: 500;
  font-size: 28px;
  line-height: 127.3%;
  color: #767676;
  margin-top: 0;
`;
const ContentDiv = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const Text = styled(Typography)`
  padding: 0 20px;
  font-family: var(--font-work-sans);
  width: 100%;
  font-size: 18px;
  line-height: 160%;
  align-items: center;
  color: #231727;
  margin-bottom: 12px;
`;
const IconDiv = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
const Icon = styled.img`
  width: 65px;
  height: 65px;
`;
export type LearnMoreModalProps = {
  open: boolean;
  onClose: () => void;
  reason: string;
};

const LearnMoreModal = ({ open, onClose, reason }: LearnMoreModalProps) => {
  const reasonObj = reasons[reason] || {};
  return (
    <Dialog open={open} fullScreen onClose={onClose}>
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
      <ContentDiv>
        <Global
          styles={css`
            .MuiDialogContent-root {
              padding: 0 !important;
            }
          `}
        />
        <IconDiv>
          <Icon src={reasonObj.mainIcon} alt={''} />
        </IconDiv>
        <WhyHost>
          {config.platformMode === 'archive' ? 'Community members became Hosts to...' : 'Why host?'}
        </WhyHost>
        <Title>{reasonObj.heading}</Title>
        <Text>{reasonObj.detail}</Text>
      </ContentDiv>
    </Dialog>
  );
};

export default LearnMoreModal;
